import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ApiService } from '@services';

/**
 * Groups service.
 *
 * @author Ihar Kazlouski
 * @class GroupsServiceClass
 * @category Services
 */
var GroupsServiceClass = /*#__PURE__*/function () {
  function GroupsServiceClass() {
    _classCallCheck(this, GroupsServiceClass);
  }

  _createClass(GroupsServiceClass, [{
    key: "apiAdminGroupsGet",
    value:
    /**
     * Groups get api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<AdminGroup[]>>} groups list promise.
     */
    function () {
      var _apiAdminGroupsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet('/admin-console-groups', _objectSpread({}, params)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiAdminGroupsGet(_x) {
        return _apiAdminGroupsGet.apply(this, arguments);
      }

      return apiAdminGroupsGet;
    }()
    /**
     * Admin console groups filter post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<AdminGroup[]>>} admin console groups list promise.
     */

  }, {
    key: "apiSearchAdminGroupsPost",
    value: function () {
      var _apiSearchAdminGroupsPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", ApiService.apiPost('/search', _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/admin-console-groups'
                }, params)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function apiSearchAdminGroupsPost(_x2) {
        return _apiSearchAdminGroupsPost.apply(this, arguments);
      }

      return apiSearchAdminGroupsPost;
    }()
    /**
     * Admin console delete group post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>>} response.
     */

  }, {
    key: "apiDeleteGroupPost",
    value: function () {
      var _apiDeleteGroupPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", ApiService.apiPost("/delete/".concat(params.id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/admin-console-groups'
                }, params)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function apiDeleteGroupPost(_x3) {
        return _apiDeleteGroupPost.apply(this, arguments);
      }

      return apiDeleteGroupPost;
    }()
    /**
     * Admin groups users get api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<GroupsUsersResponseType[]>>} admin groups users.
     */

  }, {
    key: "apiAdminUsersGet",
    value: function () {
      var _apiAdminUsersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", ApiService.apiGet('/admin-user/names', _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function apiAdminUsersGet(_x4) {
        return _apiAdminUsersGet.apply(this, arguments);
      }

      return apiAdminUsersGet;
    }()
    /**
     * Admin groups permissions get api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<GroupsPermissionsResponseType[]>>} admin groups permissions.
     */

  }, {
    key: "apiAdminPermissionsGet",
    value: function () {
      var _apiAdminPermissionsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", ApiService.apiGet('/names', _objectSpread({
                  prefixURL: '/role'
                }, params)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function apiAdminPermissionsGet(_x5) {
        return _apiAdminPermissionsGet.apply(this, arguments);
      }

      return apiAdminPermissionsGet;
    }()
    /**
     * Admin console groups update put api function.
     *
     * @author Ihar Kazlouski
     * @param {string} id Auth user id.
     * @return {Promise<ApiError | AxiosResponse<string>>} promise.
     */

  }, {
    key: "apiUpdateAdminGroupsPut",
    value: function () {
      var _apiUpdateAdminGroupsPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, params) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", ApiService.apiPut("/admin-console-groups/".concat(id || ''), params === null || params === void 0 ? void 0 : params.body, _objectSpread({}, params)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function apiUpdateAdminGroupsPut(_x6, _x7) {
        return _apiUpdateAdminGroupsPut.apply(this, arguments);
      }

      return apiUpdateAdminGroupsPut;
    }()
    /**
     * Admin group create post api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<string>>} current admin response promise.
     */

  }, {
    key: "apiAdminGroupCreatePost",
    value: function () {
      var _apiAdminGroupCreatePost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id, params) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", ApiService.apiPost("/admin-console-groups/".concat(id), _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({}, params)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function apiAdminGroupCreatePost(_x8, _x9) {
        return _apiAdminGroupCreatePost.apply(this, arguments);
      }

      return apiAdminGroupCreatePost;
    }()
  }]);

  return GroupsServiceClass;
}();

var GroupsService = new GroupsServiceClass();
export { GroupsService };